import store from 'state/store';
import { sendOpenSearchLogs } from '../../helper-functions/send-open-search-logs';
import { getHandoffContext } from '../../helper-functions/browser-handoff';
import { selectNativeSdk } from '../../../state/reducers/native-sdk-state';

// PRX-24667: log events of a native-SDK method (specification "Logging").
// Card data, personal data and secrets never go here.

export const NATIVE_SDK_LOG_EVENT_GROUP = 'cashier_revolut_pay';

export const NATIVE_SDK_LOG_EVENTS = {
  SdkLoadFailed: 'sdk_load_failed',
  ValidateFailed: 'validate_failed',
  CreateOrderFailed: 'create_order_failed',
  PaymentEvent: 'payment_event',
  DeepLinkReturn: 'deep_link_return',
  MobileReturn: 'mobile_return',
  PopupClosedWithoutEvent: 'popup_closed_without_event',
} as const;

export type TNativeSdkLogEvent = (typeof NATIVE_SDK_LOG_EVENTS)[keyof typeof NATIVE_SDK_LOG_EVENTS];

const getLayout = (state: any): string =>
  state?.initTheme?.theme_editor_settings?.customization_settings?.layout === 'amount-first'
    ? 'amount-first'
    : 'panoramic';

/**
 * Writes one event of the method. The common fields (`trace_id` when it
 * exists, `gateway_id`, `mode`, `layout`) come from the store and can be
 * overridden by `data` (for example the trace id of a loaded transaction or
 * the gateway id of a return address). `platform` goes to the device context.
 */
export const logNativeSdkEvent = (
  eventName: TNativeSdkLogEvent,
  data: Record<string, unknown> = {},
) => {
  const state = store.getState();
  const { configurations, payRequest } = selectNativeSdk(state);
  const traceId = payRequest?.traceId;

  sendOpenSearchLogs({
    ...(eventName === NATIVE_SDK_LOG_EVENTS.SdkLoadFailed && { level: 'ERROR' }),
    event_group: NATIVE_SDK_LOG_EVENT_GROUP,
    event_name: eventName,
    event_data: {
      ...(traceId && { trace_id: traceId }),
      gateway_id: configurations?.gateway_id ?? null,
      mode: configurations?.mode ?? null,
      layout: getLayout(state),
      ...data,
    },
    event_context: { platform: getHandoffContext().platform },
  });
};
